// 设置组件中的指定属性的值
const setValue = function (exp, value, context) {
    value = isNaN(value) ? '' : value
    new Function ('context', 'value', `context.${exp} = value`)(context, value)
  }
const numberInput = {
    bind (el, binding, vNode) {
        const {value,step,min,max} = binding.value;
        // 初始化lastValue
        el.lastValue = value
        // 判断是否允许小数点
        let pattern = `^[0-9]+${step?`(\.[0-9]{0,${step}})?`:''}$`;

        el.handleInputEvent = {
          keydownEvent:function(e) {
            // 获取元素的值
            const curValue = e.target.value;
            // 1 精度为0时不能录入小数点(只能输入整数)

            if (step == 0 &&  [110, 190].indexOf(e.keyCode) > 0) {
              e.preventDefault();
              return;
            }
             // 2 当录入小数点情况下，不能继续录入
            if (step>0&&curValue.indexOf('.') !=-1&& [110, 190].indexOf(e.keyCode) > 0) {
              e.preventDefault();
              return;
            }
            // 3 正常情况下照常录入
            // 支持delete(46)、Backspace(8)、Tab(9)、Esc(27)、Enter(13)、小数点(110-数字键盘)、.(190)、->(39) <-(37)
            if ([46, 8, 9, 27, 13, 110, 190, 37, 39].indexOf(e.keyCode) !== -1 ||
                // 允许全选: Ctrl+A
                (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
                // 允许复制: Ctrl+C
                (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
                // 允许粘贴: Ctrl+V
                (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
                // 允许剪切: Ctrl+X
                (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
                // 允许: home（头）, end（尾）, left（左移）, right（右移）
                (e.keyCode >= 35 && e.keyCode <= 39)) {
              // 保持默认的处理
              return;
            }
        
            // 4 小数的要符合精度要求，否则无法录入(数字以外的其他命令键可以执行)
            // 判断小数精度
            const unit = curValue.split('.');
            // 位数满足时，不能再输入
            if (unit[1] && unit[1].length == step) {
              e.preventDefault();
              return;
            }
            if(unit[0] && unit[0].indexOf(0)===0&&e.keyCode===96){
              e.preventDefault();
              return;
            }
            if(e.keyCode === 189){
              return;
            }
            // 确保数字以外的案件被拒绝执行默认动作
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
              e.preventDefault();
              return false;
            }
          },
          inputEvent:function(e){
            if(e.target.value !== '' && !new RegExp(pattern).test(e.target.value)){
              e.target.value = e.target.lastValue;
            }else{
              e.target.value=(e.target.value||'').trim()
              .replace(/。/g, '.')
              .replace(/[^\w\.-]+/g, '')
              e.target.lastValue = e.target.value;
            }
          },
          blurEvent:function(e){
            setTimeout(() => {
              let _value= e.target.value;
              const unit = _value.split('.')

              if(!unit[1]){//小数点后面为空重置
                e.target.value = unit[0];
              }
              if(min&&_value<min){
                //setValue(value, parseFloat(min),  vNode.context)
                e.target.value=min;
                binding.value.value=min;
              }
              if(max&&_value>max){
                //setValue(value, parseFloat(max),  vNode.context)
                e.target.value=max;
                binding.value.value=max;
              }
              if (e.target.value !== '' && !new RegExp(pattern).test(e.target.value)) {
                setValue(value, parseFloat(e.target.lastValue),  vNode.context)
                // 遇到非法数值，则重置为lastValue
                e.target.value = e.target.lastValue;
              }
              e.target.lastValue = e.target.value
            }, 0)
          }
        };
        el.addEventListener('keydown',el.handleInputEvent.keydownEvent,false);
        el.addEventListener('input', el.handleInputEvent.inputEvent, false);
        el.addEventListener('blur', el.handleInputEvent.blurEvent, true)
      },
      unbind (el) {
        if(el&&el.handleInputEvent){
          el.removeEventListener('keydown', el.handleInputEvent.keydownEvent, false)
          el.removeEventListener('input', el.handleInputEvent.inputEvent, false)
          el.removeEventListener('blur', el.handleInputEvent.blurEvent, true)
        }
      }
}
export default numberInput;


// WEBPACK FOOTER //
// ./src/directives/src/number-input/index.js